import React, { Fragment } from 'react';
export const text = {
  EMPTY: 'empty',
  IN_USE: 'in use',
  REQUIRES_CLEANING: 'requires cleaning',
  UNAVAILABLE: 'unavailable'
};

const TankStatusText = ({ status, capitalise }) => {
  const st = text[status] || status;
  return <Fragment>{capitalise ? `${st.charAt(0).toUpperCase()}${st.slice(1)}` : st}</Fragment>;
};

export default TankStatusText;



// WEBPACK FOOTER //
// ./src/components/tankStatusText/tankStatusText.jsx